/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import FastClick from 'fastclick'
import App from './App'
import router from './router'
import wechatPlugin from './wechat_auth/index'
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
import JsBarcode from 'jsbarcode' //条形码使用全局引用
import store from './vuex'
import wx from 'jweixin-1.6.0'
Vue.use(Lazyload);
Vue.use(Vant);
Vue.use(Toast);
Vue.config.productionTip = false
Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'wx-open-launch-weapp']
Vue.prototype.$axios = axios
// const FastClick = require('fastclick')
FastClick.attach(document.body)
// 微信授权插件初始化
let redirectUri = 'http://www.beginhealth.cn';
if(window.location.href.indexOf("getUserInformation") != -1){
  redirectUri = 'http://www.beginhealth.cn/getUserInformation';
}
if(window.location.href.indexOf("checkupList") != -1){
  redirectUri = 'http://www.beginhealth.cn/checkupList';
}
if(window.location.href.indexOf("complaint") != -1){
  redirectUri = 'http://www.beginhealth.cn/complaint';
}
Vue.use(wechatPlugin, {
  router, // 路由实例对象
  appid: 'wxfb9adef5a6cabd8a', // 您的微信appid
  responseType: 'code', // 返回类型，请填写code
  scope: 'snsapi_userinfo', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
  redirectUri: redirectUri, //微信回调地址
  getCodeCallback(next, code) {
    // 用户同意授权后回调方法
    // code：用户同意授权后，获得code值
    // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
    // next： 无论access_token是否获取成功,一定要调用该方法
    // next说明：next方法接收两个参数
    // 参数1(必填，切换到的路由地址，空字符串为当前路由，指定切换对象 next('/') 或者 next({ path: '/' })
    // 参数2为通过code值请求后端获取access_token的结果，true或者false，默认为false
    axios.get('api/wx/wxAuth/getWxOpenId', {
      params: {
        code,
        state: ''
      },
    }).then(response => {
      if (response.data.code === 0) {
        let result = response.data.result;
        if (result) {
          window.localStorage.setItem("wechatUser", JSON.stringify(result))
          // store.commit("setWechatUser",JSON.stringify(result))
          next('', code); // 获取access_toeken成功
        } else {
          next('/404'); // 获取access_token失败
        }
      }
    }).catch(() => {
      next('/404'); // ajax出现错误
    })
  },
})
router.beforeEach ((to, from, next) => {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS && to.path !== location.pathname) {
    // 此处不可使用location.replace
    location.assign(to.fullPath)
  } else {
    next()
  }
});
// router.afterEach(async(to, from) => {
//   // alert()
//   const url = window.location.origin + to.fullPath
//   // 非ios设备，切换路由时候进行重新签名
//   // // ios微信jssdk兼容性处理
//   // const u = navigator.userAgent,
//   //   isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
//   // const url = window.location.href.split('#')[0]
//   if (window.__wxjs_is_wkwebview !== true) {
//     // alert(url)
//     await axios.get('api/wx/wxAuth/getConfig', {
//       params: {
//         url
//       },
//     }).then(res => {
//       const {
//         appId,
//         nonceStr,
//         signature,
//         timestamp
//       } = res.data.result;
//       wx.config({
//         debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//         appId, // 必填，公众号的唯一标识
//         timestamp, // 必填，生成签名的时间戳
//         nonceStr, // 必填，生成签名的随机串
//         signature, // 必填，签名
//         jsApiList: ['scanQRCode', 'openLocation','getLocation'] // 必填，需要使用的JS接口列表
//       });
//     })
//   }
// })
// ios 设备进入页面则进行js-sdk签名
// if (window.__wxjs_is_wkwebview === true) {
//   const url = window.location.href.split('#')[0]
//   alert(url)
//   axios.get('api/wx/wxAuth/getConfig', {
//     params: {
//       url
//     },
//   }).then(res => {
//     const {
//       appId,
//       nonceStr,
//       signature,
//       timestamp
//     } = res.data.result;
//     wx.config({
//       debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//       appId, // 必填，公众号的唯一标识
//       timestamp, // 必填，生成签名的时间戳
//       nonceStr, // 必填，生成签名的随机串
//       signature, // 必填，签名
//       jsApiList: ['scanQRCode', 'openLocation','getLocation'] // 必填，需要使用的JS接口列表
//     });
//   })
// }
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js